import useConversationHistory from './useConversationHistory'
import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../../2compounds/AccordionBase'

const ConversationHistory = ({
  admin,
  index,
  editMode,
  data,
  formikProps,
  key,
  resetToDefault,
  reorderFields,
  toggleIsHidden,
  updateFieldLabel,
  updateDataType,
  updateCardLabel,
  isCardDirty,
  toggleIsHiddenCard,
  layoutDefaultData
}) => {
  const classes = useStyles({ admin })
  const { viewSwitcher, isOpen, setIsOpen } = useConversationHistory()
  const { label } = data

  return (
    <AccordionBase
      label={label} isOpen={admin ? true : isOpen} setIsOpen={setIsOpen}
      className={classes.root} admin={admin} index={index} data={data} isCardDirty={isCardDirty}
      resetToDefault={resetToDefault} updateCardLabel={(newValue) => updateCardLabel(index, newValue)}
      toggleIsHiddenCard={toggleIsHiddenCard} layoutDefaultData={layoutDefaultData}
    >
      {viewSwitcher(admin, index, data, formikProps)}
    </AccordionBase>
  )
}

export default ConversationHistory

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 4',
    gridRow: 'span 4',
    border: props => props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none'
  }
}))
